/* PaisaCX segmented controls: primary (gradient active), secondary and filter chips */
export function PrimaryTabs({ tabs, value, onChange, testIdPrefix = "tab" }) {
  return (
    <div className="flex w-fit max-w-full gap-1 overflow-x-auto rounded-lg border border-border bg-surface-2 p-1">
      {tabs.map((t) => (
        <button
          key={t.id}
          type="button"
          onClick={() => onChange(t.id)}
          data-testid={`${testIdPrefix}-${t.id}`}
          className={`flex items-center gap-1.5 whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-medium transition ${
            value === t.id ? "brand-gradient text-primary-foreground" : "text-muted-foreground hover:text-foreground"
          }`}
        >
          {t.icon && <t.icon className="h-3.5 w-3.5" />}
          {t.label}
        </button>
      ))}
    </div>
  );
}

export function SecondaryTabs({ tabs, value, onChange, testIdPrefix = "subtab" }) {
  return (
    <div className="mt-4 flex flex-wrap gap-1">
      {tabs.map((t) => (
        <button
          key={t.id}
          type="button"
          onClick={() => onChange(t.id)}
          data-testid={`${testIdPrefix}-${t.id}`}
          className={`whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-medium transition ${
            value === t.id ? "bg-primary/15 text-primary" : "text-muted-foreground hover:bg-surface-2 hover:text-foreground"
          }`}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}

export function FilterChips({ options, value, onChange, testIdPrefix = "filter" }) {
  return (
    <div className="flex flex-wrap gap-1">
      {options.map((o) => (
        <button
          key={o.id || o}
          type="button"
          onClick={() => onChange(o.id || o)}
          data-testid={`${testIdPrefix}-${o.id || o}`}
          className={`rounded-md border px-2.5 py-1 text-xs font-medium transition ${
            value === (o.id || o)
              ? "border-primary/40 bg-primary/15 text-primary"
              : "border-border bg-surface-2 text-muted-foreground hover:text-foreground"
          }`}
        >
          {o.label || o}
        </button>
      ))}
    </div>
  );
}
